import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePoradnik from "@/pages/artykul/kakobuy-spreadsheet-poradnik/page";
import ArticleBezpieczenstwo from "@/pages/artykul/kakobuy-bezpieczenstwo/page";
import ArticleSneakers from "@/pages/artykul/kakobuy-sneakers/page";
import ArticlePoczatkujacy from "@/pages/artykul/kakobuy-dla-poczatkujacych/page";
import ArticleStreetwear from "@/pages/artykul/kakobuy-streetwear/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-poradnik",
    element: <ArticlePoradnik />,
  },
  {
    path: "/artykul/kakobuy-bezpieczenstwo",
    element: <ArticleBezpieczenstwo />,
  },
  {
    path: "/artykul/kakobuy-sneakers",
    element: <ArticleSneakers />,
  },
  {
    path: "/artykul/kakobuy-dla-poczatkujacych",
    element: <ArticlePoczatkujacy />,
  },
  {
    path: "/artykul/kakobuy-streetwear",
    element: <ArticleStreetwear />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;